import ChadFactoryAbi from '../config/ChadFactoryAbi.json'
import ChadFactoryAbiV2 from '../config/ChadFactoryAbiV2.json'

import ChadPumpAbi from '../config/ChadPumpAbi.json'
import ChadPumpAbiV2 from '../config/ChadPumpAbiV2.json'

import InfoAbi from '../config/InfoAbi.json'

import MultiCallAbi from '../config/MultiCallAbi.json'
import MultiCallAbiV2 from '../config/MultiCallAbiV2.json'

const versions = {
  factory: {
    v2: ChadFactoryAbiV2,
    v4: ChadFactoryAbi
  },
  pump: {
    v2: ChadPumpAbiV2,
    v4: ChadPumpAbi
  },
  info: {
    v4: InfoAbi
  },
  multicall: {
    v2: MultiCallAbiV2,
    v4: MultiCallAbi
  }
}

type AbiType = keyof typeof versions
type Version = 'v2' | 'v4'

export const getAbi = (type: AbiType, version: string = 'v4') => {
  const abiSet = versions[type]
  if (version !== 'v2' && version !== 'v4') version = 'v4'

  const abi = abiSet[version as Version]

  if (!abi) {
    console.warn(`ABI not found for type: ${type}, version: ${version}`)
    return null
  }

  return abi
}

export const supportsInfoAbi = (version?: string) => {
  return version === 'v4'
}

export function getMulticallAbi(contractSet) {
  return contractSet.type === 'v2' ? MultiCallAbiV2 : MultiCallAbi
}
